import { render, staticRenderFns } from "./rukuDanju.vue?vue&type=template&id=90c1907a&scoped=true&"
import script from "./rukuDanju.vue?vue&type=script&lang=js&"
export * from "./rukuDanju.vue?vue&type=script&lang=js&"
import style0 from "./rukuDanju.vue?vue&type=style&index=0&id=90c1907a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c1907a",
  null
  
)

export default component.exports